module.exports = __webpack_public_path__ + "static/media/directory_background.106ce848.jpg";